import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getImageThumbnail(url: string, width: number = 160): string {
  // Use Supabase image rendering endpoint for efficient thumbnails
  const objectPrefix = '/storage/v1/object/public/';
  const renderPrefix = '/storage/v1/render/image/public/';
  try {
    const u = new URL(url);
    if (u.hostname.endsWith('supabase.co') && u.pathname.includes(objectPrefix)) {
      const pathAfter = u.pathname.split(objectPrefix)[1]; // "{bucket}/{filePath}"
      // Request a small square thumbnail with reasonable quality
      return `${u.origin}${renderPrefix}${pathAfter}?width=${width}&height=${width}&quality=60&resize=cover`;
    }
  } catch {
    // Not a valid URL or not a Supabase URL
  }
  return url;
}

/**
 * Returns a width-resized variant of a Supabase Storage public image via the
 * image-rendering endpoint (which also negotiates WebP/AVIF by Accept header).
 * Unlike getImageThumbnail this preserves aspect ratio — no forced square crop.
 * Non-Supabase or non-public URLs (Pexels, signed URLs) pass through unchanged.
 */
export function getOptimizedImageUrl(url: string, width: number, quality: number = 70): string {
  const objectPrefix = '/storage/v1/object/public/';
  const renderPrefix = '/storage/v1/render/image/public/';
  try {
    const u = new URL(url);
    if (u.hostname.endsWith('supabase.co') && u.pathname.includes(objectPrefix)) {
      const pathAfter = u.pathname.split(objectPrefix)[1]; // "{bucket}/{filePath}"
      return `${u.origin}${renderPrefix}${pathAfter}?width=${width}&quality=${quality}`;
    }
  } catch {
    // Not a valid URL or not a Supabase public URL — return as-is.
  }
  return url;
}
